import { AddFundsUpgradeRoute } from 'types/add-funds';

export const addFundsUpgradeRouteOrder: Array<AddFundsUpgradeRoute> = [
	'upgrade-landing',
	'add-funds-ria-amount',
	'upgrade-core-plans',
	'upgrade-accreditation',
	'upgrade-view-allocation',
	'add-funds-ria-agreements',
	'add-funds-ria-review',
	'add-funds-ria-success',
	'upgrade-success'
];

export const upgradeImagePaths = {
	BASIC: '/images/service-level/basic-upgrade-icon-large.png',
	CORE: '/images/service-level/core-upgrade-icon-large-120818.png',
	ADVANCED: '/images/service-level/core-upgrade-icon-large-120818.png',
	PREMIUM: '/images/service-level/premium-upgrade-icon-large.png'
};
